// Sistema de notificaciones
let notificationCallbacks = [];

export const notificationSystem = {
  subscribe: (callback) => {
    notificationCallbacks.push(callback);
    return () => {
      notificationCallbacks = notificationCallbacks.filter(cb => cb !== callback);
    };
  },

  show: (message, type = 'info', duration = 4000) => {
    const id = Date.now();
    const notification = { id, message, type, duration };
    
    notificationCallbacks.forEach(callback => callback(notification));
    
    if (duration > 0) {
      setTimeout(() => {
        notificationCallbacks.forEach(callback => callback({ id, action: 'remove' }));
      }, duration);
    }
    
    return id;
  },

  success: (message, duration = 4000) => {
    return notificationSystem.show(message, 'success', duration);
  },

  error: (message, duration = 4000) => {
    return notificationSystem.show(message, 'error', duration);
  },

  warning: (message, duration = 4000) => {
    return notificationSystem.show(message, 'warning', duration);
  },

  info: (message, duration = 4000) => {
    return notificationSystem.show(message, 'info', duration);
  }
};

export default notificationSystem;
